import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { authTokenSelector } from 'redux/auth/selectors';
import { fetchEvents, appendEvent } from 'redux/events/actions';
import { getEvents } from 'redux/events/selectors';
import Events from './Events';

const mapStateToProps = (state: any) => ({
  events: getEvents(state),
  authToken: authTokenSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchEvents: (token: string) => dispatch(fetchEvents(token)),
  appendEvent: (event: any) => dispatch(appendEvent(event)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Events)
